import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Preloader.css';

const Preloader = ({ onComplete }) => {
  const [phase, setPhase] = useState('enter'); // 'enter' | 'hold' | 'exit'

  useEffect(() => {
    const holdTimer = setTimeout(() => setPhase('hold'), 2400);
    const exitTimer = setTimeout(() => setPhase('exit'), 3200);
    const completeTimer = setTimeout(() => onComplete && onComplete(), 4000);

    return () => {
      clearTimeout(holdTimer);
      clearTimeout(exitTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  const text = 'NEXAWAVE';
  const letters = text.split('');

  return (
    <AnimatePresence>
      {phase !== 'done' && (
        <motion.div
          initial={{ opacity: 1 }}
          animate={{ opacity: phase === 'exit' ? 0 : 1 }}
          transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
          className="preloader-root"
        >
          <div className="preloader-inner">
            <div className="preloader-line preloader-line-top">
              <motion.div
                initial={{ scaleX: 0, originX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 0.8, delay: 0.1, ease: [0.4, 0, 0.2, 1] }}
                className="preloader-line-fill"
              />
            </div>

            <div className="preloader-line preloader-line-bottom">
              <motion.div
                initial={{ scaleX: 0, originX: 1 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 0.8, delay: 0.2, ease: [0.4, 0, 0.2, 1] }}
                className="preloader-line-fill"
              />
            </div>

            <div className="preloader-text">
              {letters.map((letter, i) => (
                <motion.span
                  key={i}
                  initial={{ y: '100%', opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.8, delay: 0.3 + i * 0.05, ease: [0.4, 0, 0.2, 1] }}
                  className="preloader-letter"
                >
                  {letter}
                </motion.span>
              ))}
            </div>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 0.5, y: 0 }}
              transition={{ delay: 0.8, duration: 1 }}
              className="preloader-sub"
            >
              Certified refurbished laptops & desktops
            </motion.p>

            <div className="preloader-bar">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: '100%' }}
                transition={{ duration: 1.5, ease: [0.4, 0, 0.2, 1] }}
                className="preloader-bar-fill"
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;
